import fecha from 'fecha';

const es: fecha.i18nSettings = {
  dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
  dayNames: [
    'Domingo',
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
  ],
  monthNamesShort: [
    'Ene',
    'Feb',
    'Mar',
    'Abr',
    'May',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Oct',
    'Nov',
    'Dic',
  ],
  monthNames: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  amPm: ['am', 'pm'] as [string, string],
  DoFn: (day: number) => `${day}°`,
};

export const humanized = {
  SECONDS_AGO: 'Hace un momento',
  A_MINUTE_AGO: 'Hace un minuto',
  MINUTES_AGO: (mins: number) => `Hace ${mins} minutos`,
  AN_HOUR_AGO: 'Hace una hora',
  HOURS_AGO: (hours: number) => `Hace ${hours} horas`,
  A_DAY_AGO: 'Hace un día',
  DAYS_AGO: (days: number) => `Hace ${days} días`,
  A_MONTH_AGO: 'Hace un mes',
  MONTHS_AGO: (months: number) => `Hace ${months} meses`,
  A_YEAR_AGO: 'Hace un año',
  YEARS_AGO: (years: number) => `Hace ${years} años`,
};

export const remaining = {
  SECONDS_AGO: 'un momento',
  A_MINUTE_AGO: 'un minuto',
  MINUTES_AGO: (mins: number) => `${mins} minutos`,
  AN_HOUR_AGO: 'una hora',
  HOURS_AGO: (hours: number) => `${hours} horas`,
  A_DAY_AGO: 'un día',
  DAYS_AGO: (days: number) => `${days} días`,
  A_MONTH_AGO: 'un mes',
  MONTHS_AGO: (months: number) => `${months} meses`,
  A_YEAR_AGO: 'un año',
  YEARS_AGO: (years: number) => `${years} años`,
};

export default es;
